<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName"></div>
  </div>
</template>

<script>
const seriesOption = {
  type: 'bar',
  seriesLayoutBy: 'row',
  label: {
    show: true,
    formatter: '{b}',
    align: 'center',
  },
  stack: 'A',
  labelLayout: {
    y: '92%',
  }
}
import {CHART_TYPE} from "@/option/common/dict";
import util from "@/option/common/util";
import {unref} from "vue";

export default {
  name: "periodBar",
  data() {
    return {
      formatter: (params, data) => {
        let content = '';
        if (!this.option.tipContent) {
          this.option.tipContent = ['维度值', '指标名', '指标值']
        }
        if (this.option.tipContent?.includes('维度值')) {
          content += `<div>${params[0].name}</div>`
        }
        params.forEach(item => {
          content += '<div>'
          if (this.option.tipContent?.includes('指标名')) {
            content += `${item.seriesName}`
          }
          if (this.option.tipContent?.includes('指标值')) {
            if (this.option.tipContent?.includes('指标名')) {
              content += '：'
            }
            const unit = this.getUnit(item.seriesName)
            content += `${item.value}${unit}`
          }
          content += '</div>'
        })
        return content
      },
      labelFormatter: (params, data) => {
        let content = '';
        if (this.option.labelContent?.includes('维度值')) {
          content += `${params.name}`
        }
        if (this.option.labelContent?.includes('指标值')) {
          if (this.option.labelContent?.includes('维度值')) {
            content += '：'
          }
          const unit = this.getUnit(params.seriesName)
          content += `${params.value}${unit}`
        }
        return content
      }
    }
  },
  methods: {
    // 获取单位
    getUnit(name) {
      if (this.prop.metrics) {
        const fieldItem = this.prop.metrics.find(item => item.name === name || item.fieldName === name) || {}
        if (fieldItem?.set?.type === 'percent') {
          return '%'
        }
        return fieldItem?.set?.indexUnit || ''
      } else {
        return ''
      }
    },
    handlerDimParam(param) {
      // 指标环图结构, 辅助指标显示在柱状图复用，通过assistTip字段加一层控制
      param.componentType = this.option.assistTip ? 'indexRingGraph' : undefined;
      return param
    },
    hexColorToRGBA(hex, alpha) {
      const rgb = []; // 定义rgb数组
      if (/^\#[0-9A-F]{3}$/i.test(hex)) {
        // 判断传入是否为#三位十六进制数
        let sixHex = "#";
        hex.replace(/[0-9A-F]/gi, function (kw) {
          sixHex += kw + kw; // 把三位16进制数转化为六位
        });
        hex = sixHex; // 保存回hex
      }
      if (/^#[0-9A-F]{6}$/i.test(hex)) {
        // 判断传入是否为#六位十六进制数
        hex.replace(/[0-9A-F]{2}/gi, function (kw) {
          // eslint-disable-next-line no-eval
          rgb.push(eval("0x" + kw)); // 十六进制转化为十进制并存如数组
        });
        return `rgba(${rgb.join(",")},${alpha / 100})`; // 输出RGB格式颜色
      } else {
        return "rgb(0,0,0)";
      }
    },
    bothSideToolFormatter(params) {
      let res = "";
      params.forEach((v, i) => {
        res += `<div>
                  <div>${i == 0 ? v.name : ""}</div>
                  <div style="display:flex;align-items:center">
                    ${v.marker}
                    <span>${v.seriesName}: ${Math.abs(v.value)} </span>
                  </div>
                </div>`;
      });
      return res;
    },
    updateChart() {
      const optionData = this.deepClone(this.dataChart);
      const {bothSide, assistTip, stack} = this.option;
      const {
        fontFamily = ''
      } = this.themeCfg
      let option = {
        title: this.getOptionTitle(),
        tooltip: {
          ...this.getOptionTip({
            trigger: "axis",
            confine: true
          }),
        },
        grid: this.getOptionGrid(),
        legend: this.getOptionLegend(),
        xAxis: this.getXAxisOption({
          data: optionData?.categories || [],
          axisLabel: {
            show: this.validData(this.option.axisLabelShow, true),
            interval: this.option.xAxisInterval || "auto",
            rotate: this.option.xAxisRotate || 0,
            textStyle: {
              color: this.option.xAxisColor || "#fff",
              fontSize: this.option.xAxisFontSize || 14,
              fontFamily: this.option.xAxisFontFamily || (fontFamily || '微软雅黑')
            },
            formatter: function (value) {
              if (typeof value === "number" && bothSide) {
                return Math.abs(value);
              }
              return value;
            },
          },
        }),
        yAxis: this.getAxisOption({
          min: this.option.yAxisMinAuto ? null : this.option.yAxisMin,
          max: this.option.yAxisMaxAuto ? null : this.option.yAxisMax,
          interval: this.option.yAxisIntervalAuto ? null : this.option.yAxisInterval,
          minInterval: this.option.yAxisminInterval,
          data: optionData?.categories || [],
          axisLabel: {
            show: this.validData(this.option.yAxisLabelShow, true),
            interval: this.option.yAxisInterval || "auto",
            rotate: this.option.yAxisRotate || 0,
            textStyle: {
              color: this.option.yAxisColor || "#fff",
              fontSize: this.option.yAxisFontSize || 14,
              fontFamily: this.option.yAxisFontFamily || (fontFamily || '微软雅黑')
            },
            formatter: function (value) {
              if (typeof value === "number" && bothSide) {
                return Math.abs(value);
              }
              return value;
            },
          },
        }),
        series: (() => {
          const barColor = this.option.barColor || [];
          const list = (optionData?.series || []).map((ele, index) => {
            return Object.assign(ele, {
              type: "bar",
              stack: stack ? 'stack' : ele.stack,
              barWidth: this.option.barWidth || 16,
              barMinHeight: this.option.barMinHeight || 0,
              itemStyle: this.getHasProp(
                  !this.switchTheme,
                  {
                    color: this.getColor(index),
                  },
                  {barBorderRadius: this.option.barRadius || 0}
              ),
              label: this.getOptionLabel({
                position: !this.option.category
                    ? this.option.labelPosition
                    : this.option.labelPosition == "top"
                        ? "right"
                        : "inside",
              }),
            });
          });
          return list;
        })(),
      };
      if (this.isDataCenter) {
        let _op = this.getDimentionOption();
        const catList = ['type', ...this.prop.metrics.map(item => item.name)]
        const valueList = ['A指标', ...this.prop.metrics.map(item => {
          const ser = _op.series.find(serItem => serItem.name === item.name)
          return ser.data[0]
        })]
        const source = [catList, valueList]
        option.dataset = {
          source,
        }
        option.legend = {}
        option.xAxis = [{type: 'category', gridIndex: 0, show: false}]
        option.yAxis = [{gridIndex: 0}]
        option.grid = [{bottom: '10%'}]
        option.series = [{
          ...seriesOption,
          label: {
            ...seriesOption.label,
            textStyle: {
              fontSize: this.option.labelShowFontSize || 14,
              color: this.option.labelShowColor || "#ffffff",
              fontWeight: this.option.labelShowFontWeight || 500
            },
          },
          barWidth: this.option.barWidth || 16,
          barMinHeight: this.option.barMinHeight || 0,
          itemStyle: this.getHasProp(
              !this.switchTheme,
              {
                color: this.option.category ? this.getHorizontalColor(0) : this.getColor(0),
              },
              {barBorderRadius: this.option.barRadius || 0}
          ),
          markLine: {
            ...this.getMarkLineDefaultSet(),
            lineStyle: {
              width: this.option.yAxisMarkLineWidth || 1,
              type: this.option.yAxisMarkLineType,
              color: this.option.yAxisMarkLineColor || "#FF0000",
            },
            data: this.option.yAxisMarkLineShow && this.getMarklineOption()
          }
        }]
        // console.log('catList>>>>', catList, valueList)
        // option.yAxis.data = _op.categories;
        // option.xAxis.data = _op.categories;
        // // 双边柱状图
        // if (bothSide) {
        //   option.tooltip.formatter = this.bothSideToolFormatter;
        // }
        // // 辅助指标显示在tooltip
        // if (this.prop.assistMetrics && this.prop.assistMetrics.length && assistTip) {
        //   option.tooltip.formatter = (params) => util.assistMetricsToolFormatter(params, this.prop, this.dataChart, _op.series)
        // }
        // option.series = _op.series.map((el, index) => {
        //   const color = this.option.category ? this.getHorizontalColor(index) : this.getColor(index);
        //   return {
        //     ...el,
        //     data:
        //       (index + 1) % 2 == 0 && bothSide
        //         ? el.data.map((item) => -item)
        //         : el.data,
        //     type: "bar",
        //     stack: stack && !el.stack ? "stack" : (el.stack || ''),
        //     barWidth: this.option.barWidth || 16,
        //     barMinHeight: this.option.barMinHeight || 0,
        //     itemStyle: this.getHasProp(
        //       !this.switchTheme,
        //       {
        //         color: color,
        //       },
        //       { barBorderRadius: this.option.barRadius || 0 }
        //     ),
        //     label: this.getOptionLabel({
        //       position: !this.option.category
        //         ? this.option.labelPosition
        //         : this.option.labelPosition == "top"
        //           ? "right"
        //           : "inside",
        //     }),
        //     markLine: {
        //       lineStyle: {
        //         width: this.option.yAxisMarkLineWidth || 1,
        //         type: this.option.yAxisMarkLineType,
        //         color: this.option.yAxisMarkLineColor || "#FF0000",
        //       },
        //       data: this.option.yAxisMarkLineShow && this.getMarklineOption()
        //     }
        //   };
        // });
      }
      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    },
  },
};
</script>
